import EA from '../helpers/init';

export default EA.Methods.copyUrl = ($this) => {
    const copyUrl = $this;
    const popup = document.querySelector('.copied-link-popup-wrapper');

    copyUrl.addEventListener('click', (e) => {
        const url = window.location.href;
        e.preventDefault();
        navigator.clipboard.writeText(url);

        if(popup) {
            popup.classList.add('active');
    
            setTimeout(() => {
                popup.classList.remove('active');
            }, 3500);
        }
    });
};
